import { render, staticRenderFns } from "./TagMentionDialog.vue?vue&type=template&id=5c74eb2b&scoped=true"
import script from "./TagMentionDialog.vue?vue&type=script&lang=js"
export * from "./TagMentionDialog.vue?vue&type=script&lang=js"
import style0 from "./TagMentionDialog.vue?vue&type=style&index=0&id=5c74eb2b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74eb2b",
  null
  
)

export default component.exports